<template>
  <div class="callCenter">
    <el-row style="margin:5px 0;" class="callCard">
      <el-col :span="6" style="padding:5px">
        <el-card shadow="hover" :style="jiuzhunum" @click.native="handleNum">
          <el-row style="height:70px;margin-top:40px;">
            <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:30px;">
              <el-col :span="14" :offset="10" align="left">外呼次数</el-col>
            </el-row>
            <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:30px;">
              <el-col :span="14" :offset="10" align="left">76次</el-col>
            </el-row>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="6" style="padding:5px">
        <el-card shadow="hover" :style="shebeinum" @click.native="handleNum">
          <el-row style="height:70px;margin-top:40px;">
            <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:30px;">
              <el-col :span="14" :offset="10" align="left">呼入次数</el-col>
            </el-row>
            <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:30px;">
              <el-col :span="14" :offset="10" align="left">39次</el-col>
            </el-row>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="6" style="padding:5px">
        <el-card shadow="hover" :style="fuwunum" @click.native="handleNum">
          <el-row style="height:70px;margin-top:40px;">
            <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:30px;">
              <el-col :span="14" :offset="10" align="left">客户回访</el-col>
            </el-row>
            <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:30px;">
              <el-col :span="14" :offset="10" align="left">15次</el-col>
            </el-row>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="6" style="padding:5px">
        <el-card shadow="hover" :style="evaluate" @click.native="handleNum">
          <el-row style="height:70px;margin-top:40px;">
            <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:30px;">
              <el-col :span="14" :offset="10" align="left">坐席服务评分</el-col>
            </el-row>
            <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:30px;">
              <el-col :span="14" :offset="10" align="left">
                <el-rate
                  v-model="4.8"
                  disabled
                  show-score
                  style="font-size:22px"
                  text-color="#ff9900"
                  score-template="{value}">
                </el-rate>
              </el-col>
            </el-row>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin:5px;" class="callCard">
      <el-col :span="8">
        <el-card shadow="hover" :style="callInnum" style="width:99%;margin-right:10px;" @click.native="handleCall">
          <el-row>
            <el-col :span="11" :push="1">
              <el-row style="height:70px;margin-top:20px;">
                <el-row style="margin-bottom:3px;height:70px;line-height:70px;font-size:30px;">
                  <el-col :span="10" :offset="14" align="left">呼入</el-col>
                </el-row>
              </el-row>
            </el-col>
            <el-col :span="11" :push="1">
              <el-row style="height:70px;margin-top:15px;">
                <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:20px;" @click.native="handleCall">
                  <el-col :span="16" :offset="8" align="left">已接通：12</el-col>
                </el-row>
                <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:20px;">
                  <el-col :span="16" :offset="8" align="left">未接通：0</el-col>
                </el-row>
                <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:20px;">
                  <el-col :span="16" :offset="8" align="left">完成率：100%</el-col>
                </el-row>
              </el-row>
            </el-col>
          </el-row>
          
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" :style="callOutnum" style="width:99%;margin-left:10px;">
          <el-row>
            <el-col :span="11" :push="1">
              <el-row style="height:70px;margin-top:20px;">
                <el-row style="margin-bottom:3px;height:70px;line-height:70px;font-size:30px;">
                  <el-col :span="10" :offset="14" align="left">呼出</el-col>
                </el-row>
              </el-row>
            </el-col>
            <el-col :span="11" :push="1">
              <el-row style="height:70px;margin-top:15px;">
                <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:20px;">
                  <el-col :span="16" :offset="8" align="left">已接通：10</el-col>
                </el-row>
                <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:20px;">
                  <el-col :span="16" :offset="8" align="left">未接通：2</el-col>
                </el-row>
                <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:20px;">
                  <el-col :span="16" :offset="8" align="left">完成率：82%</el-col>
                </el-row>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card shadow="hover" :style="callNonenum" style="width:99%;margin-left:10px;">
          <el-row>
            <el-col :span="11" :push="1">
              <el-row style="height:70px;margin-top:20px;">
                <el-row style="margin-bottom:3px;height:70px;line-height:70px;font-size:30px;">
                  <el-col :span="10" :offset="14" align="left">呼损</el-col>
                </el-row>
              </el-row>
            </el-col>
            <el-col :span="11" :push="1">
              <el-row style="height:70px;margin-top:15px;">
                <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:20px;">
                  <el-col :span="16" :offset="8" align="left">今日：3次</el-col>
                </el-row>
                <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:20px;">
                  <el-col :span="16" :offset="8" align="left">总次数：57次</el-col>
                </el-row>
                <el-row style="margin-bottom:3px;height:40px;line-height:40px;font-size:20px;">
                  <el-col :span="16" :offset="8" align="left">呼损率：18%</el-col>
                </el-row>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top:10px;">
      <el-col :span="8">
        <el-row
            style="height:44px;line-height:44px;background:#eeeeee;color:#999999;font-size:15px;"
          >
            <el-col :span="10" :offset="1" align="right">总通话时长：23小时20分</el-col>
            <el-col :span="12" :offset="1">平均通话时长：5分24秒</el-col>
          </el-row>
        <!--表格内容栏-->
        <el-table
          :border="false"
          :data="callInList"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
          style="width:99%;margin-right:10px;"
        >
          <el-table-column prop="callInTime" label="呼入时间" min-width="150" align="center"></el-table-column>
          <el-table-column prop="phone" label="联系电话" min-width="120" align="center"></el-table-column>
          <el-table-column prop="oldName" label="姓名" min-width="90" align="center"></el-table-column>
          <el-table-column prop="callStatus" label="接听状态" min-width="90" align="center"></el-table-column>
        </el-table>
        <!-- <el-row style="width:99%;margin-right:10px;" v-if="moreCallIn">
          <el-col :span="24" align="right">
            <a class="moreClass" id="moreClass" @click="showMoreCallIn">更多》</a>
          </el-col>
        </el-row> -->
      </el-col>
      <el-col :span="8">
        <el-row
            style="height:44px;line-height:44px;background:#eeeeee;color:#999999;font-size:15px;"
          >
            <el-col :span="10" :offset="1" align="right">总通话时长：17小时10分</el-col>
            <el-col :span="12" :offset="1">平均通话时长：05分15秒</el-col>
          </el-row>
        <!--表格内容栏-->
        <el-table
          :border="false"
          :data="callOutList"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
          style="width:99%;margin-left:10px;margin-right:10px;"
        >
          <el-table-column prop="callInTime" label="呼出时间" min-width="150" align="center"></el-table-column>
          <el-table-column prop="phone" label="联系电话" min-width="120" align="center"></el-table-column>
          <el-table-column prop="oldName" label="姓名" min-width="90" align="center"></el-table-column>
          <el-table-column prop="callStatus" label="接听状态" min-width="90" align="center"></el-table-column>
        </el-table>
        <!-- <el-row style="width:99%;margin-left:10px;" v-if="moreCallOut">
          <el-col :span="24" align="right">
            <a class="moreClass" id="moreClass" @click="showMoreCallOut">更多》</a>
          </el-col>
        </el-row> -->
      </el-col>
      <el-col :span="8">
        <el-row
            style="height:44px;line-height:44px;background:#eeeeee;color:#999999;font-size:15px;"
          >
            <el-col :span="10" :offset="1" align="right">呼损次数：157次</el-col>
            <el-col :span="12" :offset="1">当日呼损：3次</el-col>
          </el-row>
        <!--表格内容栏-->
        <el-table
          :border="false"
          :data="callNoneList"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
          style="width:99%;margin-left:20px;"
        >
          <el-table-column prop="callInTime" label="呼损时间" min-width="150" align="center"></el-table-column>
          <el-table-column prop="phone" label="联系电话" min-width="120" align="center"></el-table-column>
          <el-table-column prop="oldName" label="姓名" min-width="90" align="center"></el-table-column>
          <el-table-column prop="callStatus" label="接听状态" min-width="90" align="center"></el-table-column>
        </el-table>
        <!-- <el-row style="width:99%;margin-right:10px;" v-if="moreCallIn">
          <el-col :span="24" align="right">
            <a class="moreClass" id="moreClass" @click="showMoreCallIn">更多》</a>
          </el-col>
        </el-row> -->
      </el-col>
    </el-row>
    <!-- 新增dialog -->
    <el-dialog
      class="callDialog "
      title="接听中..."
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1200px"
    >
      <el-row>
        <el-col :span="14">
          <el-row style="widht:99%;height:660px;border:1px solid #ccc;margin-right:10px;">
            <el-row>
              <el-row style="height:40px;line-height:40px;background:#bee1f4;text-align:center">老人信息</el-row>
              <el-row>
                <el-col :span="6">
                  <img
                    style="height:240px;width:99%;margin-right:5px;"
                    src="@/assets/callcenter/peopel.png"
                    alt
                  />
                </el-col>
                <el-col :span="18">
                  <el-row style="height:40px;line-height:40px;background:#f4f4f4;">
                    <el-col :span="12" align="left">
                      <span>老人姓名：</span>
                      <span>刘青山</span>
                    </el-col>
                    <el-col :span="12" align="left">
                      <span>老人性别：</span>
                      <span>男</span>
                    </el-col>
                  </el-row>
                  <el-row style="height:40px;line-height:40px;background:#ffffff;">
                    <el-col :span="12" align="left">
                      <span>电话号码：</span>
                      <span>13129901245</span>
                    </el-col>
                    <el-col :span="12" align="left">
                      <span>老人名族：</span>
                      <span>汉</span>
                    </el-col>
                  </el-row>
                  <el-row style="height:40px;line-height:40px;background:#f4f4f4;">
                    <el-col :span="12" align="left">
                      <span>身份证号码：</span>
                      <span>420121194512092356</span>
                    </el-col>
                    <el-col :span="12" align="left">
                      <span>家庭住址：</span>
                      <span>湖北省武汉市江汉区108号</span>
                    </el-col>
                  </el-row>
                  <el-row style="height:40px;line-height:40px;background:#ffffff;">
                    <el-col :span="12" align="left">
                      <span>所属服务站：</span>
                      <span>莲花康养</span>
                    </el-col>
                    <el-col :span="12" align="left">
                      <span>老人年龄：</span>
                      <span>74</span>
                    </el-col>
                  </el-row>
                  <el-row style="height:40px;line-height:40px;background:#f4f4f4;">
                    <el-col :span="12" align="left">
                      <span>婚姻状况：</span>
                      <span>已婚</span>
                    </el-col>
                    <el-col :span="12" align="left">
                      <span>出生日期：</span>
                      <span>1945-12-09</span>
                    </el-col>
                  </el-row>
                  <el-row style="height:40px;line-height:40px;background:#ffffff;">
                    <el-col :span="12" align="left">
                      <span>服务类型：</span>
                      <span>入院</span>
                    </el-col>
                    <el-col :span="12" align="left">
                      <span>护理级别：</span>
                      <span>自理</span>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-row>
            <el-row style="margin-top:10px;">
              <el-row
                style="height:40px;line-height:40px;background:#bee1f4;text-align:center"
              >紧急联系人</el-row>
              <el-row style="height:40px;line-height:40px;background:#f4f4f4;">
                <el-col :span="12" align="center">
                  <span>紧急联系人：</span>
                  <span>闫冉冉</span>
                </el-col>
                <el-col :span="12" align="center">
                  <span>与老人关系：</span>
                  <span>旁系亲属</span>
                </el-col>
              </el-row>
              <el-row style="height:40px;line-height:40px;background:#ffffff;">
                <el-col :span="12" align="center">
                  <span>联系电话：</span>
                  <span>13129901245</span>
                </el-col>
                <el-col :span="12" align="center">
                  <span>家庭住址：</span>
                  <span>湖北省武汉市江汉区108号</span>
                </el-col>
              </el-row>
              <el-row style="height:40px;line-height:40px;background:#f4f4f4;">
                <el-col :span="12" align="center">
                  <span>身份证号码：</span>
                  <span>420121194512092356</span>
                </el-col>
                <el-col :span="12" align="center">
              
                </el-col>
              </el-row>
            </el-row>
            <el-row style="margin-top:10px;">
              <el-row style="height:40px;line-height:40px;background:#bee1f4;text-align:center">
                <el-col :span="22"><span style="margin-left:35px;">历史呼叫</span></el-col>
                <el-col :span="2" align="right"><a class="moreClass" v-if="moreHistory" @click="showMoreHistory">更多》</a></el-col>
              </el-row>
            </el-row>
            <!--表格内容栏-->
            <el-table
              class="historyTable"
              :border="false"
              :data="historyCallList"
              :row-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              style="width:100%;"
            >
              <el-table-column prop="callInTime" label="呼叫时间" min-width="150" align="center"></el-table-column>
              <el-table-column prop="callType" label="呼叫类型" min-width="100" align="center"></el-table-column>
              <el-table-column prop="orderType" label="工单类型" min-width="100" align="center"></el-table-column>
              <el-table-column prop="opertion" label="坐席人员" min-width="100" align="center"></el-table-column>
              <el-table-column label="操作" min-width="100" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-circle-check-outline"
                    @click="handlePlay(scope.$index, scope.row)"
                  ><img src="@/assets/callcenter/sounds.png" alt="" class="handedness" style="margin-right:2px;width:12px;height:12px;vertical-align: middle;">播放录音</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-col>
        <el-col :span="10">
          <el-row style="widht:99%;height:660px;border:1px solid #ccc;">
            <el-row
                style="height:40px;line-height:40px;background:#bee1f4;text-align:center"
              >地图定位</el-row>
            <div class="oldmanmap">
              
            </div>
          </el-row>
        </el-col>
      </el-row>
      <div class="headerImg"><img src="@/assets/callcenter/telePhone.png" alt="" class="handedness" style="margin-right:10px;"></div>
      <div class="headerClass">
        <el-button type="primary" @click="handleService">服务管理</el-button>
        <el-button type="warning" @click="handleSet">设备呼叫</el-button>
        <el-button type="danger" @click="handleComplaint">投诉管理</el-button>
      </div>
    </el-dialog>

      <!-- <el-table
          :border="false"
          :data="callInList"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
          style="width:50%;margin-right:10px;"
        >
          <el-table-column prop="callInTime" label="呼叫时间" min-width="150" align="center"></el-table-column>
          <el-table-column prop="oldName" label="坐席姓名" min-width="120" align="center"></el-table-column>
          <el-table-column prop="phone" label="通话时长" min-width="90" align="center"></el-table-column>
        </el-table> -->
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import locationgps_icon from '@/assets/map/location.png'
import watchgps_icon from '@/assets/map/watchgps_icon.png'
export default {
  name: "CallCenter",
  data() {
    return {
      //添加css样式
      jiuzhunum: {
        height: "170px",
        backgroundColor: "#ff6666",
        backgroundImage: "url(" + require("@/assets/callcenter/jiuzhu.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "30px 35px",
        color: "#fff",
        fontWeight: 500,
        paddingRight: "25px"
        // fontStyle:"italic"
      },
      shebeinum: {
        height: "170px",
        backgroundColor: "#ffcc66",
        backgroundImage: "url(" + require("@/assets/callcenter/shebei.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "30px 35px",
        color: "#fff",
        fontWeight: 500,
        paddingRight: "25px"
        // fontStyle:"italic"
      },
      fuwunum: {
        height: "170px",
        backgroundColor: "#33c5d2",
        backgroundImage: "url(" + require("@/assets/callcenter/fuwu.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "30px 35px",
        color: "#fff",
        fontWeight: 500
        // fontStyle:"italic"
      },
      evaluate: {
        height: "170px",
        backgroundColor: "#3366cc",
        backgroundImage: "url(" + require("@/assets/callcenter/qita_chart.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "30px 35px",
        color: "#fff",
        fontWeight: 500
        // fontStyle:"italic"
      },

      callInnum: {
        height: "150px",
        backgroundColor: "#60b8f7",
        backgroundImage: "url(" + require("@/assets/callcenter/callIn.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "30px 25px",
        color: "#fff",
        fontWeight: 500
        //paddingRight: "25px"
        // fontStyle:"italic"
      },

      callOutnum: {
        height: "150px",
        backgroundColor: "#56da8e",
        backgroundImage: "url(" + require("@/assets/callcenter/callOut.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "30px 25px",
        color: "#fff",
        fontWeight: 500
        //paddingRight: "25px"
        // fontStyle:"italic"
      },
      callNonenum: {
        height: "150px",
        backgroundColor: "#cc6666",
        backgroundImage: "url(" + require("@/assets/callcenter/callNone.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "30px 25px",
        color: "#fff",
        fontWeight: 500
        //paddingRight: "25px"
        // fontStyle:"italic"
      },
      callNoneList:[
        {
          callInTime: "2025/08/10 16:50:30",
          phone: "13926105832",
          oldName: "朱兆芳",
          callStatus: "未接通"
        },
        {
          callInTime: "2025/08/10 15:54:25",
          phone: "18971265320",
          oldName: "占中秋",
          callStatus: "未接通"
        },
        {
          callInTime: "2025/08/10 11:02:10",
          phone: "15978153364",
          oldName: "李丽华",
          callStatus: "未接通"
        },
        {
          callInTime: "2025/08/09 14:54:25",
          phone: "18971265320",
          oldName: "占中秋",
          callStatus: "未接通"
        },
        {
          callInTime: "2025/08/09 12:22:30",
          phone: "13926105832",
          oldName: "朱兆芳",
          callStatus: "未接通"
        }
      ],
      callInList: [
        {
          callInTime: "2025/08/10 16:22:30",
          phone: "15926105967",
          oldName: "刘青山",
          callStatus: "已接通"
        },
        {
          callInTime: "2025/08/10 15:35:40",
          phone: "13972303561",
          oldName: "李建国",
          callStatus: "已接通"
        },
        {
          callInTime: "2025/08/10 11:02:10",
          phone: "15971688892",
          oldName: "邱秀珍",
          callStatus: "已接通"
        },
        {
          callInTime: "2025/08/09 14:54:25",
          phone: "18971265320",
          oldName: "占中秋",
          callStatus: "已接通"
        },
        {
          callInTime: "2025/08/09 12:22:30",
          phone: "17764052563",
          oldName: "李爱兰",
          callStatus: "已接通"
        }
      ],

      callOutList: [
        {
          callInTime: "2025/08/10 16:50:30",
          phone: "13926105832",
          oldName: "朱兆芳",
          callStatus: "未接通"
        },
        {
          callInTime: "2025/08/10 16:05:40",
          phone: "13972303561",
          oldName: "李建国",
          callStatus: "已接通"
        },
        {
          callInTime: "2025/08/10 15:54:25",
          phone: "18971265320",
          oldName: "占中秋",
          callStatus: "未接通"
        },
        {
          callInTime: "2025/08/09 15:54:25",
          phone: "18971265320",
          oldName: "占中秋",
          callStatus: "未接通"
        },
        {
          callInTime: "2025/08/09 14:22:30",
          phone: "17764052563",
          oldName: "李爱兰",
          callStatus: "已接通"
        }
      ],
      moreCallIn: true,
      moreCallOut: true,
      dialogFormVisible: false,
      historyCallList:[
        {
          callInTime:"2025-07-24 14:23:09:24",
          callType:"呼入",
          orderType:"上门送餐",
          opertion:"航晓波",
        },
        {
          callInTime:"2025-07-24 14:55:13:45",
          callType:"呼入",
          orderType:"上门送餐",
          opertion:"航晓波",
        }
      ],
      iconLocation:{url:locationgps_icon, size: {width: 48, height: 48}},
      iconWatch:{url:watchgps_icon, size: {width: 48, height: 48}},
      markers:[],//marker点集合
      center: {lng: 0, lat: 0},//中心点
      zoom: 3,//缩放比例
      mapType:"",//地图类型，不填就是默认样式
      //设置自定义主题
      mapStyle: {
        styleJson: [
          {
            "featureType": "all",
            "elementType": "geometry",
            "stylers": {
                "hue": "#007fff",
                "saturation": 89
            }
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": {
                "color": "#ffffff"
            }
          }
        ]
      },
      moreHistory:true,
    };
  },
  methods: {
    /* 
      救助呼叫  设备呼叫  服务呼叫 跳转
    */
    handleNum(){
      console.log("aaaaaaa")
      bus.$emit("homePage", {
        type: "jump",
        path: "/CallOrderManagement",
        title: "呼叫工单管理"
      });
    },

    /* 
      呼入 呼出  跳转
    */
    handleCall(){
      console.log("aaaaaaa")
      bus.$emit("homePage", {
        type: "jump",
        path: "/CallInformationManagement",
        title: "呼叫信息管理"
      });
    },

    /* 
      呼入更多
    */
    showMoreCallIn() {
      console.log("ccccccc")
      bus.$emit("homePage", {
        type: "jump",
        path: "/CallInformationManagement",
        title: "呼叫信息管理"
      });
    },

    /* 
      呼出更多
    */
    showMoreCallOut() {
      console.log("ddddddd")
      bus.$emit("homePage", {
        type: "jump",
        path: "/CallInformationManagement",
        title: "呼叫信息管理"
      });
    },

    /* 
      历史呼叫更多
    */
    showMoreHistory(){
      this.historyCallList.push( 
        {
          callInTime:"2025-08-08 15:23:09:24",
          callType:"呼入",
          orderType:"上门送餐",
          opertion:"航晓波",
        },
        {
          callInTime:"2025-08-07 16:27:09:24",
          callType:"呼入",
          orderType:"上门送餐",
          opertion:"航晓波",
        },
        {
          callInTime:"2025-08-07 16:49:02:34",
          callType:"呼入",
          orderType:"上门送餐",
          opertion:"航晓波",
        },
      );
      this.moreHistory=false;
    },

    /* 
      播放
    */
    handlePlay(index,row){
      console.log(index,row);
    },

    /* 
      服务管理
    */
    handleService(){
      this.dialogFormVisible=false;
      bus.$emit("homePage", {
        type: "jump",
        path: "/CallOrderManagement",
        title: "呼叫工单管理"
      });
    },

    /* 
      设备呼叫
    */
    handleSet(){
      this.dialogFormVisible=false;
      bus.$emit("homePage", {
        type: "jump",
        path: "/CallInformationManagement",
        title: "呼叫信息管理"
      });
    },

    /* 
      投诉管理
    */
    handleComplaint(){
      this.dialogFormVisible=false;
      bus.$emit("homePage", {
        type: "jump",
        path: "/ComplainOrderManagement",
        title: "投诉工单管理"
      });
    },

    handler ({BMap, map}) {
      //(BMap, map)地图组件渲染完毕时触发，返回一个百度地图的核心类和地图实例。百度地图组件是异步加载，
      //请不要尝试在组件的生命周期中访问 BMap 核心类和 map 实例，如有需要，请在所需组件的 ready 事件回调函数的参数中获取。
      console.log(BMap, map)
      //武汉的经纬度 zoom为地图显示的比例
      this.center.lng = 114.31667
      this.center.lat = 30.51667
      this.zoom = 12
    },
    //获取老人的地理位置信息
    getOldmanGeoPoint(){
      this.$postJson('omc/Oldman/queryOldmanAddress').then(res=>{
        // console.log(res)
        var newArr=[];
        if(res.result!=null){
          res.result.forEach((item,index) => {
            console.log(item,index);
            //声明一个对象来存放老人地图定位的信息(title,经纬度，姓名，年龄，信息提示框的状态)
            let obj={};
            obj.lng=item.oldAddressBdGps.split(',')[0];//老人家庭住址百度经度
            obj.lat=item.oldAddressBdGps.split(',')[1];//老人家庭住址百度纬度
            obj.name=item.oldName;//title为老人姓名
            obj.oldName=item.oldName;//老人姓名
            obj.oldAddress=item.oldAddress;//l老人家庭住址
            obj.oldAge=item.oldAge;//老人年龄
            obj.infoWindowShoeFlag=false;//提示框显示的状态
            item.sex==0 ? obj.sex='男' : obj.sex='女';//性别
            //手环的信息不为null
            if(item.watchOldmanAddressVo !=null){
              obj.deviceNo=item.watchOldmanAddressVo.deviceNo;//设备id
              item.watchOldmanAddressVo.deviceStatus=='offline' ? obj.deviceStatus='离线' : obj.deviceStatus='在线';//设备是否在线
              item.watchOldmanAddressVo.wearState==0 ? obj.wearState='未佩戴' : obj.wearState='已佩戴';//是否佩戴
              obj.power=item.watchOldmanAddressVo.power;//电量
              item.watchOldmanAddressVo.lbs_type==1 ? obj.lbs_type='gps' : item.watchOldmanAddressVo.lbs_type==2 ? obj.lbs_type='lbs' : obj.lbs_type='wifi';//定位方式
              obj.bdGpslng=item.watchOldmanAddressVo.bdGps.split(',')[0];//手环百度定位的经度
              obj.bdGpslat=item.watchOldmanAddressVo.bdGps.split(',')[1];//手环百度定位的纬度
              obj.location=item.watchOldmanAddressVo.location;//手环定位的位置
              obj.locationTime=item.watchOldmanAddressVo.locationTime;//手环定位的位置
              obj.step=item.watchOldmanAddressVo.step;//手环计步数
              obj.activation=item.watchOldmanAddressVo.activation;//手环是否激活
            }
            newArr.push(obj);
          });
        }
        // console.log(newArr)
        this.markers=newArr;
        // console.log(this.markers);
      })
    },
    //点击marker点，提示信息框的显示和隐藏 老人家庭住址的定位
    handleInfoWindowOpen(marker){
      // console.log(marker);
      if(marker.infoWindowShoeFlag==false){
        marker.infoWindowShoeFlag=true;
      }else{
        marker.infoWindowShoeFlag=false;
      }
    },
    //提示信息框关闭时的状态 老人家庭住址的定位
    infoWindowClose(marker){
      // console.log(marker);
      marker.infoWindowShoeFlag=false;
    },
    //提示信息框打开是的状态 老人家庭住址的定位
    infoWindowOpen(marker){
      // console.log(marker);
      marker.infoWindowShoeFlag=true;
    },
    //点击marker点，提示信息框的显示和隐藏 孝心手环的定位
    handleInfoWindowOpenWatch(marker){
        // console.log(marker);
        if(marker.infoWindowShoeFlagWatch==false){
          marker.infoWindowShoeFlagWatch=true;
        }else{
          marker.infoWindowShoeFlagWatch=false;
        }
    },
    //提示信息框关闭时的状态  孝心手环
    infoWindowCloseWatch(marker){
      // console.log(marker);
      marker.infoWindowShoeFlagWatch=false;
    },

    //提示信息框打开是的状态  孝心手环
    infoWindowOpenWatch(marker){
      // console.log(marker);
      marker.infoWindowShoeFlagWatch=true;
    },

    //推送弹框消息  by guo 2019-10-09 11:25
    suportNotify(info) {
      var showMsg = info;
      if (window.Notification) {
        // 支持
        console.log("支持" + "Web Notifications API");
        //如果支持Web Notifications API，再判断浏览器是否支持弹出实例
        this.showMess(showMsg); //调取消息提示框的函数
      } else {
        // 不支持
        alert("不支持 Web Notifications API");
      }
    },
    showMess(data) {
      console.log(data);
      var objData = data;
      console.log(objData);
      var title = objData.title;
      var msg = objData.content;
      var urlPath = objData.url; //by guo 2019-11-14 15:02 添加  配置的需要跳转的url
      console.log(title, msg, urlPath);
      setTimeout(() => {
        console.log("1：" + Notification.permission);
        //如果支持window.Notification 并且 许可不是拒绝状态
        if (window.Notification && Notification.permission !== "denied") {
          //Notification.requestPermission这是一个静态方法，作用就是让浏览器出现是否允许通知的提示
          Notification.requestPermission(status => {
            console.log("2: " + status);
            //如果状态是同意
            if (status === "granted") {
              var notify = new Notification(title, {
                body: msg, //消息体内容
                //tag: 'avenstar', //代表通知的一个识别标签，相同tag时只会打开同一个通知窗口
                icon: require("@/assets/callcenter/telePhone.png"),
                data: {
                  url: "" //跳转页面的url
                },
                silent: true, //true代表有声，false代表无声
                sound: "..", //铃声文件的url
                requireInteraction: true //通知自动关闭,  true不关闭   默认为false 关闭
              });
              notify.onshow = () => {
                console.log("通知显示了！");
              };
              notify.onclick = () => {
                console.log("fjewjgjerhjejhjjeh");
                this.dialogFormVisible = true;
                notify.close(); //跳转页面后关闭消息提示框
              };
              notify.onclose = () => {
                console.log("你关闭了我！！！");
              };
              notify.onerror = err => {
                console.log("出错了！！！");
                throw err;
              };
            } else {
              alert("当前浏览器不支持弹出消息");
            }
          });
        } else {
          console.log("--------", title, msg);
          var that=this;
          this.$notify({
            title: title,
            message: msg,
            iconClass: "el-icon-phone-outline",
            customClass: "",
            duration: 0,
            position: "bottom-right",
            showClose() {
              console.log("aaaa");
            },
            onClose() {
              console.log("bbbb");
            },
            onClick() {
              console.log("cccc");
              var activityTab=sessionStorage.getItem('activityTab');
              if(activityTab=="/CallCenter"){
                that.dialogFormVisible = true;
              }
              this.close();
            }
          });
        }
      }, 100);
    },

     // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      // return this.rowStyle;
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },

  },
  created() {
    this.getOldmanGeoPoint();
  },
  mounted() {
    let info = {
      title: "来电提醒",
      content: "是否接听1312992312的来电",
      url: ""
    };
    this.suportNotify(info);
  },
};
</script>
<style lang="scss" scoped>
.callCenter {
  padding-bottom: 10px;
  .moreClass {
    float: right;
    font-size: 16px;
    color: #0101ff;
    text-decoration: none;
    cursor: pointer;
  }
  ::v-deep .callDialog .el-dialog{
    margin-top:10px !important;
  }
  ::v-deep .callDialog .el-dialog__body{
    padding:10px 20px !important;
  }
  .historyTable{
    overflow:auto;
    height:156px !important;
  }
  .oldmanmap{
    margin:0 0;
    border:1px solid rgb(228, 222, 222);
    .map {
      width: 100%;
      height: 615px;
    }
  }
  //地图插件·
  ::v-deep .BMap_stdMpCtrl{
    top:50px !important;
  }
  ::v-deep .citylist_popup_main{
    margin-left:45px;
  }
  /* dialogheader头部 */
  .callDialog .el-dialog__header{
    text-align: left !important;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
    .el-dialog__title{
      color:#48ca9e;
      font-size:18px;
      font-weight:900;
      margin-left:25px;
    }
  }
  .headerClass{
    position: absolute;
    top:10px;
    right:45px;
  }
  .headerImg{
    position: absolute;
    top:15px;
    left:10px;
  }
  .callCard{
    cursor: pointer;
  }
  ::v-deep .el-card__body {
    padding: 0px;
  }
}
</style>